module.exports = __webpack_public_path__ + "img/1724050635024-WhatsApp Image 2024-08-19 at 11.57.32.jpeg.903303b5.webp";